import { ProgressSpinner } from "@appretio/ui-kit";
import { type ReactNode, Suspense } from "react";
import { routeFallback } from "./LazyRoute.css";

/** Props for the LazyRoute wrapper. */
interface LazyRouteProps {
  /**
   * The lazy-loaded route content.
   */
  children: ReactNode;
}

function RouteFallback() {
  return (
    <div className={routeFallback}>
      <ProgressSpinner />
    </div>
  );
}

export function LazyRoute({ children }: LazyRouteProps) {
  return <Suspense fallback={<RouteFallback />}>{children}</Suspense>;
}
